/* eslint-disable no-debugger */
import API from "utils/axios-config";
import AWS from "utils/aws-config";
import { AWS_CONFIG } from 'constants'

import { useTextSearchService } from "features/text-search/text-search.services";

export const useSignSearchService = () => {

    const textSearchService = useTextSearchService();

    const uploadLandmarks = async (landmarks) => {
        const apiUrl = "https://oyi1gomkma.execute-api.us-east-1.amazonaws.com/sagemaker-invoker-cors";

        // const keypoints = landmarks.map(l => {
        //     return {
        //         pose_landmarks: l.poseLandmarks || [],
        //         face_landmarks: l.faceLandmarks || [],
        //         left_hand_landmarks: l.leftHandLandmarks || [],
        //         right_hand_landmarks: l.rightHandLandmarks || [],
        //     }
        // });
       
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                keypoints: landmarks,  // Matches the expected structure in the Lambda handler
            }),
        };
    
        try {
            const response = await fetch(apiUrl, requestOptions);  // Perform POST request to API Gateway
            const data = await response.json();  // Parse response as JSON
    
            if (!data || data.errorMessage) {
                throw new Error(data.errorMessage || "No response from Lambda function.");
            }

            console.log("Data from Lambda:", data);
    
            const instances = data.data?.instances || [];

            // Post-processing: search for `r.gloss` and add `results` if found
            const processedResults = await Promise.all(
                instances.map(async (r) => {
                    if (r.gloss) {
                        const searchResult = await textSearchService.search(r.gloss, "AiResultSearch");
                        if (searchResult && searchResult.length > 0) {
                            r.results = [searchResult[0]];
                            r.word = searchResult[0].word;
                        }
                    }
                    return r;  // Return the updated result
                })
            );
    
            // Filter to include only results with a `word` field
            const finalResults = processedResults.filter((r) => !!r.word);
            return finalResults;
        } catch (error) {
            console.error("Error invoking Lambda:", error);
            throw error;
        }
    };

    return {
        uploadLandmarks,
    };
};